<template style="padding-left:100px;" id="changepass">
  <div class="cpassword-container">
    <div class="d-flex w-100 m-auto p-3 justify-content-center flex-column cpassword">
      <h2>Change Password</h2>
      <!--Alert Message-->
      <ul  style="list-style: none; padding-left: 0;" v-show="updateMsgComp !=='Password updated successfully, please logout and re login.'">
        <li  v-bind:class="{ is_valid : contains_eight_characters, is_not_valid: !contains_eight_characters }">Min 8 Characters</li>
        <li  v-bind:class="{ is_valid: contains_number, is_not_valid: !contains_number }">Contains Number</li>
        <li  v-bind:class="{ is_valid: contains_uppercase, is_not_valid: !contains_uppercase }">Contains Uppercase</li>
        <li  v-bind:class="{ is_valid: contains_lowercase, is_not_valid: !contains_lowercase }">Contains Lowercase</li>
        <li  v-bind:class="{ is_valid: contains_special_character, is_not_valid: !contains_special_character }">Contains Special Character</li>
      </ul>

      <div class="alert alert-danger" v-if="isSamePassword">New Password and Old Password are Same</div>
      <div class="alert alert-danger" v-if="isConfirmPassword">New Password and Confirm Password are Not Same</div>

      <div :class="msgClass" v-if="updateMsgComp">{{ updateMsgComp }}</div>

      <form>
        <div class="form-group">
          <label class="float-left">Old Password</label>
          <div class="input-group">
            <input :type="showOldPassword ? 'text' : 'password'" class="form-control"
                   v-model="oldPassword"
                   ref="oldPassword"
                   required
                   placeholder="*Old password">
            <div class="input-group-append">
              <span class="input-group-text" @click="togglePasswordVisibility('old')">
                <i :class="showOldPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="float-left">New Password</label>
          <div class="input-group">
            <input :type="showNewPassword ? 'text' : 'password'" class="form-control"
                   v-model="newPassword"
                   ref="newPassword"
                   required
                   placeholder="*New password">
            <div class="input-group-append">
              <span class="input-group-text" @click="togglePasswordVisibility('new')">
                <i :class="showNewPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="float-left">Confirm New Password</label>
          <div class="input-group">
            <input :type="showConfirmPassword ? 'text' : 'password'" class="form-control"
                   v-model="confirmPass"
                   ref="confirmPass"
                   required
                   placeholder="*Confirm new password">
            <div class="input-group-append">
              <span class="input-group-text" @click="togglePasswordVisibility('confirm')">
                <i :class="showConfirmPassword ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-between">
          <!-- Left side -->
          <div>
            <button type="reset" class="btn btn-info mx-3">Clear</button>
          </div>

          <!-- Right side -->
          <div>
            <button type="submit" @click.prevent="changePass()" class="btn btn-success mx-3" :disabled="isDisabled">
              Change Password
            </button>
            <button v-show="!$store.state.user.enforcePasswordReset" type="reset" v-on:click="cancel()" class="btn btn-warning"> Cancel</button>
          </div>
        </div>

      </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'changepass',
  data() {
    return {
      oldPassword: null,
      newPassword: null,
      confirmPass: null,
      changePassFailed: false,
      checkingConfirmPass: false,
      updateMsg: null,
      msgClass: null,
      showOldPassword: false,
      showNewPassword: false,
      showConfirmPassword: false
    }
  },
  computed: {
    contains_eight_characters() {
      return this.newPassword && this.newPassword.length >= 8
    },
    contains_number() {
      return this.newPassword && /\d/.test(this.newPassword)
    },
    contains_uppercase() {
      return this.newPassword && /[A-Z]/.test(this.newPassword)
    },
    contains_lowercase() {
      return this.newPassword && /[a-z]/.test(this.newPassword)
    },
    contains_special_character() {
      const format = /[ !@#$%^&*()_+\-=[\]{};':"\\|,.<>?]/;
      return this.newPassword && format.test(this.newPassword)
    },
    valid_password() {
      return this.contains_eight_characters && this.contains_number
          && this.contains_uppercase && this.contains_special_character && this.contains_lowercase
    },
    isSamePassword() {
      return this.oldPassword && this.newPassword && this.oldPassword === this.newPassword
    },
    isConfirmPassword() {
      return this.newPassword && this.newPassword !== this.confirmPass
    },

    isDisabled() {
      return !this.valid_password || this.isSamePassword || this.isConfirmPassword
    },
    updateMsgComp(){
      return this.updateMsg
    }
  },
  created: function () {},
  methods: {
    togglePasswordVisibility(field) {
      if (field === 'old') {
        this.showOldPassword = !this.showOldPassword;
      } else if (field === 'new') {
        this.showNewPassword = !this.showNewPassword;
      } else if (field === 'confirm') {
        this.showConfirmPassword = !this.showConfirmPassword;
      }
    },
    async cancel(){
      console.log("cancel executing")
      this.$router.push('/')
    },
    changePass() {
      console.log("username",this.$store.state.userName)

      if (this.isDisabled) {
        return;
      }

      this.updateMsg = null

      // URL encode the password before sending
      const encodedOldPassword = encodeURIComponent(this.oldPassword);
      const encodedNewPassword = encodeURIComponent(this.newPassword);

      axios.post(`/auth/change-password`, {
        oldPassword: encodedOldPassword,
        newPassword: encodedNewPassword
      },{headers: {
          'Content-Type': 'application/json'
        }})
          .then(response => {
            console.log("responss",response)
            if (response.status === 200) {
              this.msgClass = 'alert alert-success';
              this.updateMsg = 'Password updated successfully, please logout and re login.';
              setTimeout(function () {
                window.location.href = '#/logout'
                window.location.reload()
              }, 2000);
              this.oldPassword = ""
              this.newPassword = ""
              this.confirmPass = ""
            }
          })
          .catch(error => {
            this.updateMsg = error.response && error.response.data ?
                error.response.data.error + ' Change Password Failed' : 'Change Password Failed';
            this.msgClass = 'alert alert-danger';
          });
    }
  }
}
</script>

<style scoped>
.cpassword-container {
  display: flex;
  width: 100vh;
  height: 75vh;
  justify-content: center;
  align-content: center;
  align-items: center;
  align-self: center;
  padding-top: 50px;
}

.cpassword {
  box-shadow: 1px 2px 2px 3px #a7aeaa;
}

.is_valid {
  color: green
}

.is_not_valid {
  color: red
}

.input-group-append {
  cursor: pointer;
}

.btn.btn[disabled] {
  color: black;
}
</style>
